import { type ReactNode, useEffect, useId, useRef } from 'react';
import { cn, PaletteUtils } from '@shared/utils';
import { Text } from '@shared/widgets';
import styles from './Textarea.module.css';

interface ITextareaProps {
  className?: string;
  textareaClassName?: string;
  label?: ReactNode;
  fitContent?: boolean;
  rows?: number;
  placeholder?: string;
  required?: boolean;
  value?: string;
  onChange?: (value: string) => void;
}

export const Textarea = (props: ITextareaProps) => {
  const ref = useRef<HTMLTextAreaElement>(null);
  const id = useId();

  useEffect(() => {
    if (!props.fitContent || !ref.current) return;

    ref.current.style.height = '0';
    ref.current.style.height = `${ref.current.scrollHeight}px`;
  }, [props.fitContent, props.value, ref.current]);

  return (
    <div className={cn(props.className)}>
      {props.label && (
        <label htmlFor={id} className='w-full'>
          <Text size='sm' color='secondary'>
            {props.label} {props.required ? ' *' : ''}
          </Text>
        </label>
      )}
      <textarea
        ref={ref}
        className={cn(
          '!transition-colors !duration-200',
          PaletteUtils.isInsigniaPalette && ['hover:bg-white', 'focus:border-b-primary focus:bg-white dark:focus:text-white'],
          PaletteUtils.isVcfcPalette && [
            'rounded-2xl',
            '!border !border-light/70 !bg-white dark:!border-transparent dark:!bg-white/10',
            'hover:!border-primary dark:hover:!border-light/70',
          ],
          styles['textarea'],
          styles['textarea_on-ice'],
          props.textareaClassName,
        )}
        rows={props.rows}
        placeholder={props.required ? `${props.placeholder} *` : props.placeholder}
        required={props.required}
        value={props.value}
        onChange={(e) => props.onChange?.(e.target.value)}
      />
    </div>
  );
};
